import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    initialize() {
        super.initialize();

        this.startX = null;
        this.scrollLeft = null;
        this.ratio = null;
        this.scrollRatio = null;
        this.doUpdate = true;
        this.doDrag = true;

        this.update = (event) => this._update(event);
        this.enter = (event) => this._enter(event);
        this.leave = (event) => this._leave(event);
        this.dragStart = (event) => this._dragStart(event);
        this.dragEnd = (event) => this._dragEnd(event);
        this.dragMove = (event) => this._dragMove(event);
    }

    connect() {
        this.wrapper = this.makeWrapper();
        this.thumb = this.makeThumb();
        this.run();
        this.resizeObserver = new ResizeObserver(() => this._update());
        this.resizeObserver.observe(this.element);
    }

    disconnect() {
        this.element.removeEventListener('scroll', this.update);
        this.element.removeEventListener('mouseenter', this.enter);
        this.element.removeEventListener('mouseleave', this.leave);
        this.thumb.removeEventListener('mousedown', this.dragStart);
        window.removeEventListener('mouseup', this.dragEnd);
        window.removeEventListener('resize', this.update);
        window.removeEventListener('mousemove', this.dragMove);
        super.disconnect();
    }

    run() {
        this.wrapper.appendChild(this.thumb);
        this.element.after(this.wrapper);
        this.element.style.cssText = 'overflow-x: hidden !important;';

        setTimeout(() => {
            this._update();
            this.element.addEventListener('scroll', this.update);
            this.element.addEventListener('mouseenter', this.enter);
            this.element.addEventListener('mouseleave', this.leave);
            this.thumb.addEventListener('mousedown', this.dragStart);
            window.addEventListener('mouseup', this.dragEnd);
            window.addEventListener('resize', this.update);
            window.addEventListener('mousemove', this.dragMove);
        }, 500);
    }

    makeWrapper() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('sticky-scroller');
        wrapper.setAttribute('data-turbo-temporary', 'true');

        return wrapper;
    }

    makeThumb() {
        const thumb = document.createElement('div');
        thumb.classList.add('sticky-scroller-thumb');

        return thumb;
    }

    _update() {
        if (this.doUpdate) {
            this.doUpdate = false;

            window.requestAnimationFrame(() => {
                const wrapperWidth = this.element.clientWidth;
                const wrapperScrollLeft = this.element.scrollLeft;
                const contentScrollWidth = this.element.firstElementChild.scrollWidth;
                const thumbWidth = (wrapperWidth / contentScrollWidth) * 100;
                const thumbLeft = (wrapperScrollLeft / contentScrollWidth) * 100;

                this.ratio = wrapperWidth / contentScrollWidth;
                this.scrollRatio = contentScrollWidth / (contentScrollWidth - wrapperWidth);

                this.thumb.style.cssText = `
                    width: ${thumbWidth}%;
                    left: ${thumbLeft}%;
                `;

                if (wrapperWidth >= contentScrollWidth) {
                    this.wrapper.classList.add('d-none');
                } else {
                    this.wrapper.classList.remove('d-none');
                }

                this.doUpdate = true;
            });
        }
    }

    _enter() {
        this.wrapper.classList.add('sticky-scroller-hover');
    }

    _leave() {
        this.wrapper.classList.remove('sticky-scroller-hover');
    }

    _dragStart(event) {
        this.startX = event.pageX - this.element.offsetLeft;
        this.scrollLeft = this.element.scrollLeft;
        application.element.classList.add('pointers-none');
        application.element.classList.add('user-select-none');
        this.wrapper.classList.add('sticky-scroller-hover');
    }

    _dragEnd() {
        this.startX = null;
        this.scrollLeft = null;
        application.element.classList.remove('pointers-none');
        application.element.classList.remove('user-select-none');
        this.wrapper.classList.remove('sticky-scroller-hover');
    }

    _dragMove(event) {
        if (this.doDrag) {
            this.doDrag = false;

            window.requestAnimationFrame(() => {
                if (this.startX !== null && this.scrollLeft !== null && this.ratio !== null && this.scrollRatio !== null) {
                    const delta = event.pageX - this.startX;

                    this.element.scrollLeft = this.scrollLeft + delta / this.ratio;
                }

                this.doDrag = true;
            });
        }
    }
}
